<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    persistent
    max-width="60%"
  >
    <v-card class="mx-auto pa-6">
      <base-material-card
        color="warning"
        icon="mdi-account-edit"
        title="แจ้ง ส่วนกลาง ปรับปรุงข้อมูลบุคลากร"
        class="px-5 py-3"
      />

      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-container grid-list-md>
            <v-row>
              <!-- แสดงชื่อพนักงาน -->
              <v-col cols="12" class="text-center font-weight-bold">
                {{ personnelInfo.id_card }} {{ personnelInfo.frist_names }}
              </v-col>

              <!-- รายละเอียดการแก้ไข -->
              <v-col cols="12">
                <v-textarea
                  v-model="localData.personnel_temporary_notifyDetail"
                  outlined
                  label="คำร้องขอแก้ไข : รายละเอียดแก้ไข"
                  rows="3"
                  required
                  :rules="[v => !!v || 'กรุณากรอกรายละเอียด']"
                />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          rounded
          @click="$emit('input', false)"
        >
          <v-icon left>mdi-close</v-icon>
          ยกเลิก
        </v-btn>
        <v-btn
          color="warning"
          rounded
          @click="handleSubmit"
        >
          <v-icon left>mdi-pencil</v-icon>
          บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "NotifyDialog",
  
  props: {
    value: {
      type: Boolean,
      default: false
    },
    personnelInfo: {
      type: Object,
      default: () => ({})
    },
    notificationData: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    localData: {
      get() {
        return this.notificationData;
      },
      set(value) {
        this.$emit("update:notificationData", value);
      }
    }
  },

  methods: {
    handleSubmit() {
      if (this.$refs.form.validate()) {
        this.$emit("submit");
      }
    }
  }
};
</script>